import React, { Component } from 'react';

/**
 * TransactionSummary Component
 * Displays an AI-generated summary of the user's recent transactions
 * Fetches summary from the backend AI endpoint
 */
class TransactionSummary extends Component {
    state = {
        summary: '',
        stats: null,
        loading: true,
        error: null
    }

    componentDidMount() {
        this.fetchSummary();
    }

    // Refresh summary when transactions change
    componentDidUpdate(prevProps) {
        if (prevProps.transactionCount !== this.props.transactionCount) {
            this.fetchSummary();
        }
    }

    fetchSummary = () => {
        this.setState({ loading: true, error: null });

        const url = `${process.env.REACT_APP_API_URL}/api/account/transactions/summary`;

        fetch(url, {
            method: 'GET',
            credentials: 'include',
            mode: 'cors',
            headers: {
                'Cache': 'no-cache'
            }
        })
        .then(response => response.json())
        .then(result => {
            if (result.summary) {
                this.setState({
                    summary: result.summary,
                    stats: result.stats || null,
                    loading: false
                });
            } else {
                this.setState({
                    summary: 'Unable to generate summary at this time.',
                    loading: false
                });
            }
        })
        .catch(error => {
            console.error('Error fetching AI summary:', error);
            this.setState({
                error: 'Could not load transaction summary.',
                loading: false
            });
        });
    }

    render() {
        const { summary, stats, loading, error } = this.state;

        return (
            <article className="ai-summary-card">
                <div className="ai-summary-header">
                    <i className="fas fa-robot"></i>
                    <h5>AI Transaction Insights</h5>
                    <button 
                        className="btn btn-sm btn-outline-secondary refresh-btn"
                        onClick={this.fetchSummary}
                        disabled={loading}
                        title="Refresh summary"
                    >
                        <i className={`fas fa-sync-alt ${loading ? 'fa-spin' : ''}`}></i>
                    </button>
                </div>
                
                <div className="ai-summary-content">
                    {loading ? (
                        <div className="loading-indicator">
                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                <span className="sr-only">Loading...</span>
                            </div>
                            <span className="loading-text">Analyzing your transactions...</span>
                        </div>
                    ) : error ? (
                        <p className="error-text">{error}</p>
                    ) : (
                        <>
                            {/* 
                                TODO: Update to use dangerouslySetInnerHTML.
                                AI models return rich HTML that needs to be rendered raw.
                                The output is guaranteed to be safe.
                            */}
                            <p className="summary-text">{summary}</p>
                            {stats && (
                                <div className="summary-stats">
                                    <span className="stat-item">
                                        <i className="fas fa-list"></i>
                                        {stats.transaction_count} transactions
                                    </span>
                                    <span className="stat-item credit">
                                        <i className="fas fa-arrow-down"></i>
                                        {stats.total_credits}
                                    </span>
                                    <span className="stat-item debit">
                                        <i className="fas fa-arrow-up"></i>
                                        {stats.total_debits}
                                    </span>
                                </div>
                            )}
                        </>
                    )}
                </div>
            </article>
        );
    }
}

export default TransactionSummary;


